<template>
    <div class="t-page_dialog t-work-area">
        <h1>{{ pageText.title }} <span v-if="mobileState && $route.query.sel && $route.query.sel !== 'all'"
                                       @click.prevent="CloseDialog()">{{ pageText.subtitle }}</span></h1>
        <cmp-dialog></cmp-dialog>
    </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/dialogPage.json' : 'staticText',
        main: {
            title: "Сообщения",
            subtitle: "Список контактов"
        }
    };
    import Vue from 'vue'

    import {store} from '../../store/index'
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import Dialog from '../../vue_components/Dialog/Index.vue'

    export default {
        data() {
            return {
                pageText: {}
            }
        },
        components: {
            'cmp-dialog': Dialog
        },
        computed: {
            ...mapGetters(['mobileState', 'newMsg'])
        },
        watch: {
            newMsg() {
                if (this.newMsg.length) {
                    this.LoadDialogList();
                    let index = this.newMsg.indexOf(parseInt(this.$route.query.sel));
                    if (index >= 0) {
                        this.LoadMessageList(this.$route.query.sel).then(() => {
                            this.OpenDialogMsg(parseInt(this.$route.query.sel));
                            store.dispatch('dialog/OpenDialog', parseInt(this.$route.query.sel));
                            this.ScrollBottom();
                        });
                    }
                }
            }
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapMutations(['SpliceMsg', 'OpenDialogMsg']),
            ...mapActions('dialog', ['LoadMessageList', 'LoadDialogList']),
            CloseDialog() {
                this.$router.push({name: 'dialog', query: {sel: 'all'}});
            },
            ScrollBottom() {
                setTimeout(() => {
                    let height = document.querySelector('.t-messageList__wrapper').clientHeight;
                    let elem = !this.mobileState ?
                        document.querySelector('.t-messageList__scroll').querySelector('.bar--wrapper') :
                        document.querySelector('.t-messageList__body');
                    elem.scrollTop = height;
                }, 1000);
            },
            Load(pageText) {
                this.pageText = pageText;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            }
        },
        beforeRouteLeave(to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteUpdate(to, from, next) {
            if (to.query.sel ) {
                if (to.query.sel !== 'all'){
                    if (this.newMsg.length>0) {
                        let index = this.newMsg.indexOf(parseInt(to.query.sel));
                        if (index >= 0) {
                            this.OpenDialogMsg (parseInt(to.query.sel));
                        } else {
                            this.LoadMessageList(to.query.sel).then(() => {
                                store.dispatch('dialog/OpenDialog', parseInt(to.query.sel));
                                next();
                            });
                        }

                    } else
                        this.LoadMessageList(to.query.sel).then(() => {
                            store.dispatch('dialog/OpenDialog', parseInt(to.query.sel));
                            next();
                        });
                }
                else
                    this.LoadDialogList().then(()=>{
                        next();
                    });
            } else {
                if (to.query.userId)
                    store.dispatch('dialog/GetUserSel', to.query.userId).then((data) => {
                        next({name: 'dialog', query: data})
                    });
                else
                    next();
            }

        },
        beforeRouteEnter(to, from, next) {
            let count = 0;

            let pageText = {};

            if (to.query.userId){
                store.dispatch('dialog/GetUserSel', to.query.userId).then((data) => {
                    next({name: 'dialog', query: data})
                });
            }
            else {
                // Запрос для получения собственного ID нужно разкоментировать в STORE
                store.dispatch('dialog/LoadUser').then(() => {
                    count++;
                    RunNext();
                });
                store.dispatch('dialog/LoadDialogList').then(() => {
                    count++;
                    RunNext();
                });
                store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                    pageText = data;
                    count++;
                    RunNext();
                });
                store.dispatch('staticText/LoadDialogText').then(() => {
                    count++;
                    RunNext();
                });
                store.dispatch('handbook/LoadEmoji').then(() => {
                    count++;
                    RunNext();
                });
                if (to.query.sel && to.query.sel !== 'all')
                    store.dispatch('dialog/LoadMessageList', to.query.sel).then(() => {
                        count++;
                        store.dispatch('dialog/OpenDialog', parseInt(to.query.sel));
                        RunNext();
                    });
            }

            let RunNext = () => {
                if (count > 5 && to.query.sel && to.query.sel !== 'all')
                    next(vm => vm.Load(pageText));
                if (count > 4 && (!to.query.sel || to.query.sel === 'all'))
                    next(vm => vm.Load(pageText));
            }
        }
    }
</script>

<style lang="sass">
    @media (max-width: 769px)
        .t-page_dialog h1
            display: flex
            align-items: baseline
            justify-content: space-between
            span
                font-size: 12px
                font-weight: normal
</style>


// WEBPACK FOOTER //
// src/vue_pages/Dialog/Index.vue